import store from '@/store';

export const deviceIsAbleToApplePay = () => {
    if(ApplePaySession && ApplePaySession.canMakePayments()) {
        store.commit('applePayPayment/setIsReadyToPay', true);
    }
};
